import React, { memo } from 'react'
import PropTypes from 'prop-types'
import ToTopOnMount from 'Components/ToTopOnMount'
import SideLink from '../SideLink'
import {
  _SideMenuCol,
  _LinkContainer,
} from './styles'

const SideMenu = ({ asFiller = false }) => (
  <>
    <ToTopOnMount />
    <_SideMenuCol>
      {
        asFiller ? null : (
          <_LinkContainer>
            <SideLink
              url={'/manage/profile'}
              iconName={'profile-material'}
              label={'Profile'}
              alt={'go to user profile page'}
            />
            <SideLink
              url={'/manage/saved-alert'}
              iconName={'saved-alert'}
              label={'Saved Alerts'}
              alt={'go to saved alert page'}
            />
            <SideLink
              url={'/manage/favourite'}
              iconName={'favourite'}
              label={'Favourites'}
              alt={'go to favorite page'}
            />
            <SideLink
              url={'/manage/email-preferences'}
              iconName={'email'}
              label={'Email Preferences'}
              alt={'go to email preferences page'}
            />
          </_LinkContainer>

        )
      }
    </_SideMenuCol>
  </>
)

SideMenu.propTypes = {
  asFiller: PropTypes.bool,
}

export default memo(SideMenu)
